// Anketa pod článkem — hlas = +1 reputace, správný názor po vyhodnocení = +5.
import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ChartBar, CheckCircle } from "@phosphor-icons/react";
import { useAuth } from "../../contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BlogPoll({ slug }) {
    const { user, login } = useAuth();
    const [data, setData] = useState(null);
    const [busy, setBusy] = useState(false);

    const load = useCallback(() => {
        axios.get(`${API}/blog/${slug}/poll`).then((r) => setData(r.data)).catch(() => {});
    }, [slug]);
    useEffect(() => { load(); }, [load]);

    if (!data?.poll) return null;
    const { poll, counts = [], total = 0, my_vote } = data;
    const resolved = poll.status === "resolved";

    const vote = async (i) => {
        if (!user) { toast("Pro hlasování se přihlas", { action: { label: "Přihlásit", onClick: login } }); return; }
        setBusy(true);
        try {
            const r = await axios.post(`${API}/blog/${slug}/poll/vote`, { option: i });
            if (r.data.first_vote) toast.success("Hlas uložen — +1 reputace!");
            else toast.success("Hlas změněn");
            load();
        } catch (e) { toast.error(e.response?.data?.detail || "Hlasování selhalo"); }
        finally { setBusy(false); }
    };

    return (
        <div className="border border-fa-yellow/30 bg-fa-yellow/5 p-5 my-8 space-y-3" data-testid="blog-poll">
            <div className="font-mono text-[9px] uppercase tracking-[0.25em] text-fa-yellow flex items-center gap-1.5">
                <ChartBar size={12} weight="fill" /> Anketa manažerů {resolved && "· vyhodnoceno"}
            </div>
            <div className="font-display font-black text-lg" data-testid="blog-poll-question">{poll.question}</div>
            <div className="space-y-1.5">
                {poll.options.map((opt, i) => {
                    const pct = total ? Math.round(100 * (counts[i] || 0) / total) : 0;
                    const isMine = my_vote === i;
                    const isCorrect = resolved && poll.correct_option === i;
                    const showBars = my_vote != null || resolved;
                    return (
                        <button key={i} type="button" disabled={busy || resolved} onClick={() => vote(i)}
                                data-testid={`blog-poll-option-${i}`}
                                className={`w-full text-left relative border px-3 py-2.5 transition-colors overflow-hidden
                                    ${isCorrect ? "border-fa-mint bg-fa-mint/10" : isMine ? "border-fa-yellow/70" : "border-white/15 hover:border-fa-yellow/50"}
                                    ${resolved ? "cursor-default" : "cursor-pointer"}`}>
                            {showBars && (
                                <div className={`absolute inset-y-0 left-0 ${isCorrect ? "bg-fa-mint/15" : "bg-white/5"}`}
                                     style={{ width: `${pct}%` }} />
                            )}
                            <div className="relative flex items-center justify-between gap-2 font-mono text-[11px]">
                                <span className="flex items-center gap-2">
                                    {isCorrect && <CheckCircle size={13} weight="fill" className="text-fa-mint" />}
                                    <span className={isMine ? "text-fa-yellow font-bold" : "text-white/80"}>{opt}</span>
                                    {isMine && <span className="text-[8px] uppercase text-fa-yellow/70">tvůj hlas</span>}
                                </span>
                                {showBars && <span className="tabular-nums text-white/50">{pct}% ({counts[i] || 0})</span>}
                            </div>
                        </button>
                    );
                })}
            </div>
            <div className="font-mono text-[9px] text-white/40 flex flex-wrap items-center gap-2">
                <span>{total} hlasů</span>
                {!resolved && <span>· hlas = +1 reputace · správný názor po vyhodnocení = +5 reputace</span>}
                {resolved && poll.resolve_note && <span className="text-fa-mint">· {poll.resolve_note}</span>}
                {resolved && my_vote != null && (
                    my_vote === poll.correct_option
                        ? <span className="text-fa-mint font-bold">Trefil ses! +5 reputace</span>
                        : <span className="text-orange-300">Tentokrát vedle.</span>
                )}
            </div>
        </div>
    );
}
